import type { UnitCircleWidgetConfig } from '../unit-circle.model';

/** Full-featured unit circle: trig lines, projections, special angles, and snap. */
export const UNIT_CIRCLE_FULL_PRESET: UnitCircleWidgetConfig = {
  id: 'unit-circle-full',
  type: 'unit-circle',
  params: {
    point: { angle: '\\pi/4', snap: true, coordinateLabel: true, axisProjections: true },
    trigLines: { lines: ['sin', 'cos'], referenceTriangle: true },
    specialAngles: { showAngles: true, showCoords: true, showTraces: true },
    quadrants: { labels: true, signIndicators: true },
    axisMarkers: 'radians',
  },
  display: {
    coordinateSystem: {
      boundingbox: { xStart: -2, xEnd: 2, yStart: -2, yEnd: 2 },
      grid: { type: 'lines', visible: true },
    },
  },
};
